import React from 'react'

const SupportPageTitle = ({text}) => {
  return (
    <div className='fs-1 fw-semibold mb-4 mb-xl-5'>{text}</div>
  )
}

export default SupportPageTitle